import { ActionTypes } from "../constants";
import initialState from "./initialState";


export default (state = initialState.modals, { type, payload = {} }) => {
  switch (type) {
    case ActionTypes.MODAL_REJECT_PROJECT_TOGGLE:
      return {
        ...state,
        rejectProject: !state.rejectProject
      };
    case ActionTypes.MODAL_TOGGLE:
      return {
        ...state,
        spModalToggle: {
          isOpen: !state.spModalToggle.isOpen,
          selectedItemId: payload
        }
      };
    case ActionTypes.MODAL_APPROVE_TOGGLE:
      return {
        ...state,
        approveModalToggle: {
          approveModalIsOpen: !state.approveModalToggle.approveModalIsOpen,
          approveSelectedItemId: payload
        }
      };

    default:
      return state;
  }
};
